import { useContext } from 'react'
import { SmartClaimContext } from '../context/SmartClaimContext'

export const useSmartClaim = () => useContext(SmartClaimContext)
